import { FC } from "react";
import { CXWorkspaceSettingsLayout } from "../CXWorkspaceSettingsLayout";
import { CXPlansPage } from "../CXPlansPage";

export const CXWorkspacePlansPage: FC = () => (
  <CXWorkspaceSettingsLayout>
    <CXPlansPage />
  </CXWorkspaceSettingsLayout>
);
